export const getCredentialListPagination = (state) => state.getIn(['ui', 'credentialList', 'pagination']);

export const getCredentialListSidebarCollapsed = (state) => state.getIn(['ui', 'credentialList', 'sidebarCollapsed']);

export const getCredentialListFilters = (state) => state.getIn(['ui', 'credentialList', 'filters']);

export const getCredentialListForm = (state) => state.getIn(['ui', 'credentialList', 'form']);

export const getModerateCredentialListForm = (state) => state.getIn(['ui', 'credentialList', 'moderateForm']);

export const getCredentialListView = (state) => state.getIn(['ui', 'credentialList', 'view']);

// Returns list of the credentials id, which is currently shown
export const getCredentialListDataset = (state) => state.getIn(['ui', 'credentialList', 'dataset']);
// Return moderated credentials count
export const getModeratedCredential = (state) => state.getIn(['ui', 'credentialList', 'moderatedCount']);
